import { API, getUID } from 'utils/Helper';

export const getMembers = async (uid) => {
  const response = await fetch(`${API}/api/members/${uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || "Failed to fetch members");
  }
  return response.json();
};

export const getTodayRewards = async (uid) => {
  const response = await fetch(`${API}/api/rewards/${uid}?filter=today`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || "Failed to fetch rewards");
  }
  return response.json();
};

export const editProfile = async (data) => {
  const response = await fetch(`${API}/editProfile`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error("Failed to update profile");
  return response.json();
};

export const sendOtp = async (to) => {
  const response = await fetch(`${API}/send-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ to }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to send OTP");
  return data;
};

export const getMyProfile = async (uid) => {
  const response = await fetch(`${API}/api/myprofile/${uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch profile");
  return response.json();
};

export const getLevel = async () => {
  const response = await fetch(`${API}/admin/getLevel`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch level list");
  return response.json();
};

export const getReferralCode = async (uid) => {
  const response = await fetch(`${API}/get-referral-code/${uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch referral code");
  return response.json();
};

export const getReferralLink = async (uid) => {
  const response = await fetch(`${API}/get-referral-link/${uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch referral link");
  return response.json();
};

export const getAffiliateAll = async (uid) => {
  const response = await fetch(`${API}/api/myAffiliate/${uid}?filter=all`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch affiliate all");
  return response.json();
};

export const getDepositBonusLevelHistory = async (uid) => {
  const response = await fetch(`${API}/api/deposit-bonus-level-history/${uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch deposit bonus history");
  return response.json();
};

export const getBetBonusLevelHistory = async (uid) => {
  const response = await fetch(`${API}/api/bet-bonus-level-history/${uid}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to fetch bet bonus history");
  return response.json();
};

export const updatePreferences = async ({ uid, ...preferences }) => {
  const response = await fetch(`${API}/api/users/preferences`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, ...preferences }),
  });
  if (!response.ok) throw new Error("Failed to update preferences");
  return response.json();
};
